import {createAction} from '@reduxjs/toolkit';

import type {ChannelCategory} from '@mattermost/types/channel_categories';

export const receivedChannelCategories = createAction<ChannelCategory[]>('sidebar/actions/receivedChannelCategories');
